import styled from 'styled-components'

const Header = styled.h1`
  color: #af1214;
  text-align: center;
  margin-top: 2rem;
  padding-bottom: 1rem;
`

const PageHeader = () => (
  <Header>File Uploads</Header>
)

export { Header, PageHeader }
